import { render, staticRenderFns } from "./ChangeMT5PasswordTab.vue?vue&type=template&id=43ed5ddb"
import script from "./ChangeMT5PasswordTab.vue?vue&type=script&lang=js"
export * from "./ChangeMT5PasswordTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports